import { render, staticRenderFns } from "./CartOverviewWidget.vue?vue&type=template&id=1973cf56&"
import script from "./CartOverviewWidget.vue?vue&type=script&lang=ts&"
export * from "./CartOverviewWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VApp,VIcon})
